Namespace('Customer.Views.Reports')

class Customer.Views.Reports.OperatorAvailabilityTableRowView extends Backbone.View
  template: JST['backbone/templates/customer/reports/operator_availability/operator_availability_table_row']
  className: 'operator-availability-table-row operator-availability-table-content-row'

  initialize: ({reportItem, pendingIncluded}) ->
    @reportItem = reportItem
    @pendingIncluded = pendingIncluded

  render: =>
    @$el.html(@template(
      loginStatus: @_getLoginStatus(),
      loginStatusClassName: @_getLoginStatusClassName(),
      operatorName: @reportItem.get('operator_name'),
      groupName: @reportItem.get('users_group_name'),
      ticketsCount: @reportItem.get('assigned_tickets_count'),
      ticketsPendingIncluded: @pendingIncluded,
      ticketsPendingCount: @reportItem.get('assigned_tickets_pending_count'),
      operatorStatus: @reportItem.get('operator_status'),
      operatorStatusType: @reportItem.get('operator_status_type'),
      operatorStatusIcon: @getStatusIcon(@reportItem.get('operator_status_type').toLowerCase()),
      operatorStatusTime: @formatDurationMilliseconds(@reportItem.get('operator_status_time_milliseconds')),
      averageAssignedTime: @formatDurationMilliseconds(@reportItem.get('average_assigned_time_milliseconds')),
      attendedTicketsDrilldownUrl: @_getDrilldownUrl('attended_tickets'),
      averageHandleTimeDrilldownUrl: @_getDrilldownUrl('average_handle_time')
    ))
    @

  formatDurationMilliseconds: (milliseconds) ->
    @getOperatorStatusTime(moment.duration(milliseconds))

  getDays: (duration) ->
    "#{Math.floor(duration.asDays())}"

  getHours: (duration) ->
    "#{duration.hours()}".padStart(2, '0')

  getMinutes: (duration) ->
    "#{duration.minutes()}".padStart(2, '0')

  getSeconds: (duration) ->
    "#{duration.seconds()}".padStart(2, '0')

  getOperatorStatusTime: (duration) ->
    days = @getDays(duration)
    hours = @getHours(duration)
    minutes = @getMinutes(duration)
    seconds = @getSeconds(duration)
    return "#{days}d #{hours}hs #{minutes}m #{seconds}s" if days != '0'
    return "#{Number(hours).toString()}hs #{minutes}m #{seconds}s" if hours != '00'
    return "#{Number(minutes).toString()}m #{seconds}s" if minutes != '00'
    return "#{Number(seconds).toString()}s"

  getStatusIcon: (status) ->
    return 'fa fa-play' if status == 'available'
    return 'fa fa-pause' if status == 'paused'
    return 'fa fa-stop' if status == 'offline'
    return 'fa fa-ban' if status == 'null'

  _getLoginStatus: ->
    if @reportItem.get('login_status') == 'logged_in'
      @_getTranslation('logged_in_status')
    else if @reportItem.get('login_status') == 'logged_out'
      @_getTranslation('logged_out_status')
    else
      @_getTranslation('MISSING')

  _getLoginStatusClassName: ->
    classNames = {logged_in: 'logged-in', logged_out: 'logged-out'}
    classNames[@reportItem.get('login_status')]

  _getTranslation: (field) ->
    I18n.t("customer.reports.operator_availability.#{field}")

  _getDrilldownUrl: (drilldown_type) ->
    timezone = moment().format('Z')
    return '/customer/operator_availability/' + @reportItem.get('operator_user_id') + '/drilldowns/' + drilldown_type +
      "?timezone=#{timezone}"
